import { useRouter } from 'next/router'
import { useMemo } from 'react'

/**
 * Custom hook that converts Next.js router query parameters to an object with only string values.
 * Handles the case where query parameters can be arrays by taking the first element.
 *
 * @returns An object with all query parameters as strings
 */
export const useStringQuery = (): Record<string, string> => {
  const router = useRouter()

  return useMemo(() => {
    const stringQuery: Record<string, string> = {}

    Object.entries(router.query).forEach(([key, value]) => {
      if (value !== undefined) {
        // Handle array values by taking the first element
        stringQuery[key] = Array.isArray(value) ? value[0] : value
      }
    })

    return stringQuery
  }, [router.query])
}
